import { Box, TextField as MuiTextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { useFormContext } from '../../contexts/FormContext';

const TextField = ({ field }: { field: any }) => {
  const { formData, getFormDataItem, handleChange } = useFormContext();

  const label = field.hasOwnProperty('help') ? (
    <>
      {field.label}
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <ChartHelpTooltip chartType={field.help} type="field" />
      </Box>
    </>
  ) : (
    field.label
  );

  return (
    <Grid size={field.size || 12} key={field.name}>
      <MuiTextField
        label={label}
        fullWidth
        required={field.required || false}
        disabled={field.disabled || false}
        multiline={field.multiline || false}
        rows={field.rows || 1}
        type={field.type}
        name={field.name}
        value={getFormDataItem(formData, field.name) || ''}
        onChange={(e) => handleChange(e, field)}
      />
    </Grid>
  );
};

export default TextField;
